import { Component, inject, signal } from '@angular/core';
import { UserService } from '../../services/user-service';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

@Component({
  selector: 'app-user-password-change',
  imports: [NzButtonModule, NzIconModule, NzFlexModule, NzTypographyModule],
  templateUrl: './user-password-change.html',
  styleUrl: './user-password-change.scss',
})
export class UserPasswordChange {
  userService = inject(UserService);
  newPassword: string = '';
  isLoading = signal(false);
  readonly userId = inject<number>(NZ_MODAL_DATA);
  onChangePassword(): void {
    this.isLoading.set(true);
    this.userService.resetPassword(this.userId).subscribe({
      next: (newPass: string) => {
        this.newPassword = newPass;
        this.isLoading.set(false);
      },
      error: (error) => {
        console.error('Error changing password:', error);
        this.isLoading.set(false);
      },
    });
  }
}
